import { render, staticRenderFns } from "./DocumentTestPreview.vue?vue&type=template&id=56ee6665&"
import script from "./DocumentTestPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTestPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports